import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { firebaseAuth, logComponentLoad } from '../../../../config/constants.js'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';

class ExpensesDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }


    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ExpensesDashboard");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    render() {

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        const uploadDocument = this.state.user && this.state.user.email && this.state.user.email == 'ivanmworozi@gmail.com'
            ? <h1>Upload Document - <Link to={'/dashboard/addDocument'}>Add Document (ivan only)</Link></h1>
            : 'no email'

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.expensesDashboard
            ? <div>

                <h1>Stock Payment - <Link to={'/dashboard/stockPayment'}>Stock Item Payment (Send payment of Stock item to Beyonic)</Link></h1>
                <h1>Upload Daily Expense - <Link to={'/dashboard/dailyExpenses'}>Upload Daily Expense Single items</Link></h1>
                <h1>Upload Expense List - <Link to={'/dashboard/expensesUpload'}>Upload Daily Expense File</Link></h1>
                <h1>Pay Printing Charge - <Link to={'/dashboard/payPrintingCharges'}>Pay Printing Charges</Link></h1>
                <h1>Supplies List - <Link to={'/suppliesList'}>Supplies List</Link></h1>
                <h1>Receipt List - <Link to={'/dashboard/receipList'}>View List of Receipts Entered</Link></h1>
                <h1>Search Receipt - <Link to={'/dashboard/searchReceiptNumber'}>Search For Receipt</Link></h1>
                {uploadDocument}
                

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (<div>

            {wholeUI}

        </div>);
    }
}

export default ExpensesDashboard;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/ExpensesDashboard.js